import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { Button } from 'common/components/antd/Button/Button';
import { ROUTES_MAPPING } from 'navigation/constants/route.constants';
import {
  SContainer,
  SHeader,
  STitle,
  SContent,
  SButtonContainer,
} from './assets.layout.styles';
import { HeaderComponent } from './components/Header/Header.component';
import { EAssetsPageGetParams, EAssetsPageGetParamsActionTypes } from '../assets/enums/assets.enum';


const AssetsLayout = (): ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <SContainer>
      <STitle>{t('assets.title')}</STitle>
      <SHeader>
        <HeaderComponent />
      </SHeader>
      <SContent>
        <SButtonContainer>
          <div
            style={{
              marginRight: 16,
            }}
          >
            <Button
              onClick={(): void => {
                const url = ROUTES_MAPPING.PROTECTED.ASSETS;
                const actionGetParam = EAssetsPageGetParams.Action;
                const actionGetParamValue = EAssetsPageGetParamsActionTypes.Create;
                navigate(`${url}?${actionGetParam}=${actionGetParamValue}`);
              }}
              type="primary"
            >
              {t('assets.button.add')}
            </Button>
          </div>
        </SButtonContainer>
        <Outlet />
      </SContent>
    </SContainer>
  );
};

export default AssetsLayout;
